var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"isOpen":_vm.isShow,"close":_vm.close,"save":_vm.save,"title":_vm.title}},[_c('FileInput',{attrs:{"onSelect":_vm.onSelect,"filename":_vm.filename,"accept":_vm.accept,"placeholder":"Choose file"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }